import Vue from 'vue'
import Vuex from 'vuex'
import localStorage from '../utils/localStorage.js'
import mtm from './modules/mtm'
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

export default new Vuex.Store({
	// strict: process.env.NODE_ENV !== 'production',
	state: {
		//isLogin: localStorage.get('ACCESS_TOKEN') ? true : false,
		userInfo: JSON.parse(localStorage.get('USER_INFO')),
		token: localStorage.get('ACCESS_TOKEN'),
		expires_time:localStorage.get('EXPIRED_TIME'),
		aliyun_oss:null,
		// Header判断是否登录使用
		is_login: false,
		setting: null
	},
	getters: {
		// 路由，页面中实时判断是否登录过期
		isLoginDynamic: (state) => () => {
			return !!(state.token && Date.now() / 1000 < state.expires_time)
		},
		isSettingLoad: (state) => () => {
			return !!state.setting
		}
	},
	mutations: {
		login(state, provider) {
			state.token = provider.token;
			state.expires_time = provider.expires_time;
			state.is_login = true
			localStorage.set('ACCESS_TOKEN',provider.token)
			localStorage.set('EXPIRED_TIME',provider.expires_time)

		},
		logout(state) {
			state.loginInfo = {};
			state.userInfo = {};
			state.token = null
			state.is_login = false
			localStorage.remove('ACCESS_TOKEN')
			localStorage.remove('EXPIRED_TIME')
			localStorage.remove('USER_INFO')
		},
		setUserInfo(state, provider) {
			state.userInfo = provider;
			localStorage.set('USER_INFO',provider)
		},
		setAliYunOSS(state, provider) {
			state.aliyun_oss = provider;
		},
		update_login_state(state, bool) {
			state.is_login = bool
		},
		updateSetting(state, setting) {
			state.setting = setting
			console.error(state)
		}
	},
	actions: {},
	modules: {
		mtm
	},
	plugins: [createPersistedState()],
})
